module.exports = __webpack_public_path__ + "static/media/desktop_GA-2100-1A1ER_01.034736bb.jpg";